import { ComponentSettings } from "../settings/settings";

const settings = {
  permission: {
    /** May the user transfer a whole case to another system? */
    transferCase: false,
    /** May the user transfer a single comment/solution to another system? */
    transferPost: false
  },
  text: {
    transferCase: {
      de: "Fall übertragen",
      en: "Transfer case",
      nl: "Casus overdragen"
    },
    transferPost: {
      de: "Übertragen",
      en: "Transfer",
      nl: "Overdragen"
    },
    transferTo: {
      de: "Übertragen nach",
      en: "Transfer to",
      nl: "Overdragen naar"
    },
    transferCaseQuestion: {
      de: "Soll dieser Fall wirklich in das andere System übertragen werden?",
      en: "Do you really want to transfer this case to the other system?",
      nl: "Wilt u deze casus echt overdragen naar het andere systeem?"
    },
    transferPostQuestion: {
      de: "Soll dieser Eintrag wirklich in das andere System übertragen werden?",
      en: "Do you really want to transfer this entry to the other system?",
      nl: "Wilt u dit item echt overdragen naar het andere systeem?"
    },
    alreadyTransferred: {
      de: "Bereits übertragen",
      en: "Already transferred",
      nl: "Al overgedragen"
    },
    transferredFrom: {
      de: "Übertragen von",
      en: "Transferred from",
      nl: "Overgedragen van"
    },
    transferredTo: {
      de: "Übertragen nach",
      en: "Transferred to",
      nl: "Overgedragen naar"
    },
    transferCaseSuccess: {
      de: "Der Fall wurde übertragen.",
      en: "The case was transferred.",
      nl: "De casus is overgedragen."
    },
    transferPostSuccess: {
      de: "Der Eintrag wurde übertragen.",
      en: "The entry was transferred.",
      nl: "Het item is overgedragen."
    },
    transferFailed: {
      de: "Die Übertragung ist fehlgeschlagen. Bitte versuchen Sie es erneut.",
      en: "The transfer failed. Please try again.",
      nl: "De overdracht is mislukt. Probeer het opnieuw."
    }
  },
  list: {},
  url: {},
  field: {},
  additionalInfo: {
    /**
     * Systems this customer may transfer cases to.
     * An empty list disables the whole transfer feature for the customer, so
     * this is what limits the feature to RAD and RHI. It cannot be expressed
     * with `permission` alone: getDefaultPermission() grants every permission
     * to the admin role when a customer supplies no override, which would show
     * the buttons to admins of every other customer.
     */
    transferTargets: [] as string[]
  }
};

export const transfer: ComponentSettings<typeof settings> = settings;
